const getCookie = function (token, cdnUrl) {
    console.log('attempting to get CF cookies...');

    fetch(`${cdnUrl}/cf-auth?token=${token}`, {
        credentials: 'include',
        method: 'POST',
    }).then(
        (json) => {
            console.log(json);
            if (json.status === 200) {
                localStorage.setItem('cf-auth-token', token);
            } else {
                console.log('failed to get CF cookies');
            }
        },
        (error) => {
            console.log(error);
        }
    );
};

const getCdnUrl = function () {
    const envString = (
        document.querySelector('html').dataset.env || ''
    ).toLowerCase();

    if (envString.startsWith('stage')) {
        return 'https://ridecommand.riderx-stage.com';
    }
    if (envString.startsWith('test')) {
        return 'https://ridecommand.riderx-test.com';
    }
    if (envString.startsWith('dev')) {
        return 'https://ridecommand.riderx-dev.com';
    }
};

const getIsEpiserver = function () {
    return document.querySelector('html').dataset.plc != null;
};

if (!getIsEpiserver()) {
    const cdnUrl = getCdnUrl();
    if (cdnUrl) {
        const token =
            new URLSearchParams(location.search).get('cfToken') ||
            localStorage.getItem('cf-auth-token');

        if (token) {
            getCookie(token, cdnUrl);
        }
    }
}
